import { useMutation, useQueryClient } from "react-query";

import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";

import { keys } from "./Keys";
import { IAlarmScheduleModel } from "../../services/alarm-schedule-data-service/Models";
import AlarmScheduleAdministrationDataService from "../../services/alarm-schedule-data-service/AlarmScheduleAdministrationService";




type MutationContextType = {
    previousInstances: IAlarmScheduleModel[] | undefined;
};

export type UseDeleteAlarmScheduleParams = {
    organizationID: number,
    groupID: number,
} & BaseUseMutationParameters<void, number>;

export function useDeleteAlarmSchedule({
    organizationID,
    groupID,
    onError,
    onSuccess
}: UseDeleteAlarmScheduleParams) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, number, MutationContextType>(
        async (id) => {
            await AlarmScheduleAdministrationDataService.deleteAlarmSchedule(
                organizationID,
                groupID,
                id
            );
        },
        {
            onMutate: async (item: number) => {

                await queryClient.cancelQueries(keys.all);

                const previousInstances = queryClient.getQueryData<IAlarmScheduleModel[]>(
                    keys.alarmSchedules(
                        organizationID,
                        groupID,
                        true
                    )
                );

                queryClient.setQueryData<IAlarmScheduleModel[]>(
                    keys.alarmSchedules(
                        organizationID,
                        groupID,                        
                        true
                    ),
                    (old?: IAlarmScheduleModel[]) => {
                        return old?.filter(t => t.id !== item) ?? [];
                    }
                );

                return {
                    previousInstances
                };
            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _runTicket, context) => {

                if (error && context?.previousInstances) {
                    queryClient.setQueryData<IAlarmScheduleModel[]>(
                        keys.alarmSchedules(
                            organizationID,
                            groupID,
                            true
                        ),
                        context?.previousInstances
                    );
                }

                queryClient.invalidateQueries(keys.alarmSchedules(organizationID, groupID, true));
            }
        }
    );
}
